export const EX2XL_REQUEST = "EX2XL_REQUEST"
export const EX2XL_SUCCESS = "EX2XL_SUCCESS"
export const EX2XL_FAIL = "EX2XL_FAIL"
export const EX2XL_RESET = "EX2XL_RESET"
